module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAA4CAYAAAArQgIlAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAACLSURBVEhL7dbBDYUgEEXR56+AUABN0AQl0wQ9EAogdPAVMsSZSKLuXMxZwXgl6srtf8BDl7iUgpQSaq2w1sJ7D+fcuCbiHsYYaXcKIYwbfrQf+okrcy7i1hqtpDkXsTGGVtKci7i/zMqcv/oa6PFKzplWJ/EYdzTmNOY05jTmNOY05jTmPhK/+FUDdq8CY83QRookAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/oldmemorabilia.png
// module id = /F71
// module chunks = 1